import { Alert, Box, Button,  Container, FormControl, InputLabel, LinearProgress, MenuItem, Paper, Select, Skeleton, Snackbar, Stack, Table, TableBody, TableContainer, TableHead, TextField, Typography } from '@mui/material'
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import React, { useEffect, useRef, useState } from 'react'
import TableRow from '@mui/material/TableRow';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Apercu from './Apercu';

export default function HistoriqueCredits() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
      }));
      
      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }));
    const [Chargement, setChargement] = useState(false);
    const [removeSuccess, setRemoveSuccess] = useState(false);
    const [Progession, setProgession] = useState(false);
    const [valVendeurs, setvalVendeurs] = useState('Tout');
    const [valCamions, setvalCamions] = useState('Tout');
    const [ListVendeur, setListVendeur] = useState([]);
    const [ListCamion, setListCamion] = useState([]);
    const [ListVentes, setListVentes] = useState([]);
    const [showApercu, setShowApercu] = useState(false);
    const [currentVente, setcurrentVente] = useState([]);
    const [Total, setTotal] = useState(0);

    const userData = useSelector(state => state.userData)
    const id = userData.id;
    const apitoken = userData.apitoken;
    const apiUrl = process.env.REACT_APP_API_URL;

    const navigate = useNavigate();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setRemoveSuccess(false);
      };
    
    function formatDateToFrench(dateString) {
        const date = new Date(dateString);
      
        // Formater la date en "jour/mois/année"
        const formattedDate = date.toLocaleDateString('fr-FR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
      
        // Formater l'heure en "heures:minutes" sans les secondes
        const formattedTime = date.toLocaleTimeString('fr-FR', {
          hour: '2-digit',
          minute: '2-digit',
        });
      
        return `${formattedDate} à ${formattedTime}`;
      }
      

    const formatDate = (dateString) => {
        const [date] = dateString.split('T');
        const [year, month, day] = date.split('-');
        return `${year}-${month}-${day}`;
      };

    const dateChargementField = useRef('')

    const handleVendeurChange = (event) => {
        setvalVendeurs(event.target.value);
      };
      const handleCamionChange = (event) => {
        setvalCamions(event.target.value);
      };

      const toggleApercu = () => {
        setShowApercu(prevState => !prevState);
      };
      const ShowApercu = (vente) => {
        setcurrentVente(vente);
        toggleApercu()
      }

      const getVendeurs=async () => {
        try {
        const response = await axios.post(`${apiUrl}vendeurs/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        setListVendeur(response.data);
        }
     catch (error) {
      navigate('/');    
    }
    }

    const getCamions=async () => {
        try {
        const response = await axios.post(`${apiUrl}camions/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        setListCamion(response.data);
        }
      catch (error) {
      navigate('/');    
      }
      }

      const getCredits=async () => {
        setChargement(true);
        try {
        const response = await axios.post(`${apiUrl}list/historique/credits/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        setListVentes(response.data);
        }
     catch (error) {
      navigate('/');    
    }
    setChargement(false);
    }

const calculateSum = (products) => {
  return products.reduce((total, product) => {
    if (product.total === 0) {
      product.total = 0;
    }

    
    const montant = product.total * 1.0025


    return total + montant;
  }, 0);
};


const exportCSV = () => {

    let listFiltre = [...ListVentes];

    // Filtre vendeur
    if (valVendeurs !== "Tout") {
        listFiltre = listFiltre.filter(
            vente => vente.vendeur?.id === valVendeurs
        );
    }

    // Filtre camion
    if (valCamions !== "Tout") {
        listFiltre = listFiltre.filter(
            vente => vente.camion?.id === valCamions
        );
    }

    const rows = [];

    // En-tête
    rows.push([
        "Client",
        "Code client",
        "Vendeur",
        "Camion",
        "Secteur",
        "Montant",
        "Date Vente",
        "Date Règlement"
    ]);

    listFiltre.forEach(vente => {

        const client =
            `${vente.client?.nom || ""} ${vente.client?.prenom || ""}`.trim();

        const codeClient =
            vente.client?.client_code || "";

        const vendeur =
            vente.vendeur?.nom || "";

        const camion =
            vente.camion?.designation || "";

        const secteur =
            vente.secteur?.designation || "";

        const montant =
            Number(vente.total || 0) * 1.0025;

        const dateVente =
            vente.date
                ? formatDateToFrench(vente.date)
                : "";

        const dateReglement =
            vente.date_reglement
                ? formatDateToFrench(vente.date_reglement)
                : "";

        rows.push([
            client,
            codeClient,
            vendeur,
            camion,
            secteur,
            montant.toFixed(2),
            dateVente,
            dateReglement
        ]);

    });

    const csvContent =
        "\uFEFF" +
        rows
            .map(row =>
                row
                    .map(value =>
                        `"${String(value ?? "").replace(/"/g, '""')}"`
                    )
                    .join(";")
            )
            .join("\r\n");

    const blob = new Blob(
        [csvContent],
        {
            type: "text/csv;charset=utf-8;"
        }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;
    link.download = "Historique_credits.csv";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
};

    function ShowList() {
        if(ListVentes.length > 0){
          let listFiltre=ListVentes
          if(valVendeurs!=="Tout") {
            listFiltre = listFiltre.filter(vente => vente.vendeur["id"] === valVendeurs)
        }
        if(valCamions!=="Tout") {
          listFiltre = listFiltre.filter(vente => vente.camion["id"] === valCamions)
      }
          setTotal(calculateSum(listFiltre))
          return listFiltre.map(Ventes => {
            return(
              <StyledTableRow key={Ventes._id}>
              <StyledTableCell component="th" scope="row">
              <Typography variant="h6"  color="secondary">
            {Ventes.client["nom"]}  {Ventes.client["prenom"]}
            </Typography>
              <Box> {Ventes.client["client_code"]}</Box>
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {Ventes.vendeur["nom"]}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {Ventes.camion["designation"]}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {Ventes.secteur["designation"]}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {(Ventes.total * 1.0025).toFixed(2)} Dhs
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {Ventes.date!=="" ? formatDateToFrench(Ventes.date) : ''}
              </StyledTableCell>
            <StyledTableCell component="th" scope="row">
              {Ventes.date_reglement!=="" ? formatDateToFrench(Ventes.date_reglement) : ''}
              </StyledTableCell>
              <StyledTableCell align="right">
                <Box>
              <Button sx={{ width:'140px' }} variant="outlined" color='secondary' startIcon={<VisibilityIcon />} onClick={() => ShowApercu(Ventes)}>
              Aperçu
              </Button>  
              </Box>
              </StyledTableCell>
            </StyledTableRow>
            )
      
          })
          }
          else {
            return (
              <StyledTableRow>
              <StyledTableCell align='center' colSpan={8} component="th" scope="row">
              Pas de données
              </StyledTableCell>
            </StyledTableRow>
            )
          }
          }

      useEffect(() =>{
        getCredits();
        getVendeurs();
        getCamions();
        },[]);
  return (
    <Container maxWidth="lg" sx={{ marginTop: '40px' }}>

        <Typography variant="h4" align='center' color="primary">
        Historique des crédits
        </Typography>

        <Box display="flex" width="100%" mt={5}>
        <Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={150} />
         :
<FormControl sx={{ minWidth: 150 }}>
          <InputLabel id="demo-simple-select-label">Vendeurs</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valVendeurs}
          label="Vendeurs"
          onChange={handleVendeurChange}
        >
          <MenuItem value='Tout'>Tout</MenuItem>
          {ListVendeur.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.nom}
         </MenuItem>
       ))}
          </Select>
          </FormControl>
}
</Box>
<Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px',marginLeft:'20px' }}  variant="rounded" height={56} width={150} />
         :
<FormControl sx={{ minWidth: 150,marginLeft:2 }}>
          <InputLabel id="demo-simple-select-label">Camions</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valCamions}
          label="Camions"
          onChange={handleCamionChange}
        >
          <MenuItem value='Tout'>Tout</MenuItem>
          {ListCamion.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.designation}
         </MenuItem>
       ))}
          </Select>
          </FormControl>
}
</Box>

           <Box mt={2} style={{ marginLeft: 'auto' }}>

            <Button variant="contained" size='large' color="success" onClick={exportCSV} >
    Exporter CSV
  </Button>
           </Box> 

        </Box>

        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={200} />
         :
         <>
        <TableContainer sx={{ marginTop: '20px' }} component={Paper}>
          
          { Progession ?
    <Box >
  <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
        <LinearProgress color="success" />
      </Stack>
    </Box>
            :
            ''
            }
          
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Client</StyledTableCell>
            <StyledTableCell>Vendeur</StyledTableCell>
            <StyledTableCell>Camion</StyledTableCell>
            <StyledTableCell>Secteur</StyledTableCell>
            <StyledTableCell>Montant</StyledTableCell>
            <StyledTableCell>Date Vente</StyledTableCell>
            <StyledTableCell>Date Règlement</StyledTableCell>
            <StyledTableCell align="right">Actions</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ShowList/>
          <StyledTableRow>
              <StyledTableCell align='center' colSpan={8} component="th" scope="row">
              Total : {Total.toFixed(2)} Dhs
              </StyledTableCell>
            </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
    </>
}
<Apercu Show={showApercu} toggleApercu={toggleApercu} currentVente = {currentVente}/>

<Snackbar open={removeSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Vente réglée avec succès
        </Alert>
      </Snackbar>

    </Container>
  )
}
